(function() {
  var btn = document.getElementById('pp-scroll-top');
  if (!btn) return;

  btn.addEventListener('click', function() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });

  /* Track whichever CTA is actually showing right now, not a fixed one:
     before a photo is uploaded the "Upload Image" trigger (.ppu__trigger)
     is the call to action and .pp-buy-wrap (holding the real Add to Cart
     button, .product-form__submit) is display:none; after upload
     .pp-buy-wrap unhides and the ATC button takes over. .ppu__trigger
     itself never gets hidden — it just restyles into an "edit photo"
     control — so which one is live has to be checked on every tick, not
     resolved once at load. */
  var uploadBtn = document.querySelector('.ppu__trigger');
  var atcBtn = document.querySelector('.product-form__submit');

  function isRendered(el) {
    return !!el && el.offsetParent !== null;
  }

  window.addEventListener('scroll', function() {
    var target = isRendered(atcBtn) ? atcBtn : (isRendered(uploadBtn) ? uploadBtn : null);
    btn.classList.toggle('visible', !!target && target.getBoundingClientRect().bottom < 0);
  }, { passive: true });
})();
